import React, { useState } from "react";
import DrawerComponent from "../ui/Drawer";
import { styled } from "styled-components";
import LabelText from "../ui/LabelText";
import CloseIcon from "@mui/icons-material/Close";
import { ForawrdBackwardButton } from "../styled-components/PageHeaderStyles";
import SecondaryButton from "../ui/SecondaryButton";

const DrawerContainer = styled.div`
  background: ${({ theme }) => theme.playerContentBackground};
  .pitch-info-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }
  .pitch-info-btn {
    display: flex;
    width: 220px;
    flex-direction: column;
    gap: 8px;
  }
  .content-header {
    width: 100%;
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  }
`;

interface PitchInfoProps {
  isOpen: boolean;
  onClose: () => void;
}

const PitchInfo: React.FC<PitchInfoProps> = ({ isOpen, onClose }) => {
  const [selectedTeam, setSelectedTeam] = useState<string | null>("System fit");
  const [selectedPlay, setSelectedPlay] = useState<string | null>(null);

  const handleTeamSelect = (label: string) => {
    setSelectedTeam((prevSelectedButton) => (prevSelectedButton === label ? null : label));
  };

  const handlePlaySelect = (label: string) => {
    setSelectedPlay((prevSelectedButton) => (prevSelectedButton === label ? null : label));
  };

  return (
    <div className="pitch-info-drawer">
      <DrawerComponent open={isOpen} onClose={onClose} styleVariant={"pitch-info"} customClassName="sidebar-drawer-main pitch-drawer">
        <DrawerContainer className="main-drawer-container">
          <div className="drawer-header">
            <LabelText className="drawer-title">Pitch Info</LabelText>
            <div className="header-buttons">
              <ForawrdBackwardButton onClick={onClose}>
                <CloseIcon className="cta-btn-icons" />
              </ForawrdBackwardButton>
            </div>
          </div>
          <div className="pitch-info-content">
            <div className="content-header">
              <LabelText className="header-text">Team</LabelText>
            </div>
            <div className="pitch-info-btn">
              <SecondaryButton
                iconType="pc"
                label="Player counters"
                isSelected={selectedTeam === "Player counters"}
                onClick={() => handleTeamSelect("Player counters")}
              />
              <SecondaryButton
                iconType="none"
                label="System fit"
                isSelected={selectedTeam === "System fit"}
                onClick={() => handleTeamSelect("System fit")}
              />
              <SecondaryButton
                iconType="none"
                label="Passing network"
                isSelected={selectedTeam === "Passing network"}
                onClick={() => handleTeamSelect("Passing network")}
              />
              <SecondaryButton
                iconType="none"
                label="Optimal pathways"
                isSelected={selectedTeam === "Optimal pathways"}
                onClick={() => handleTeamSelect("Optimal pathways")}
              />
              <SecondaryButton
                iconType="none"
                label="Areas of control"
                isSelected={selectedTeam === "Areas of control"}
                onClick={() => handleTeamSelect("Areas of control")}
              />
            </div>
          </div>
          <div className="pitch-info-content">
            <div className="content-header">
              <LabelText className="header-text">Play</LabelText>
            </div>
            <div className="pitch-info-btn">
              <SecondaryButton
                iconType="flowPlay"
                label="Flow of play"
                isSelected={selectedPlay === "Flow of play"}
                onClick={() => handlePlaySelect("Flow of play")}
              />
              <SecondaryButton
                iconType="thraetMap"
                label="Threat map"
                isSelected={selectedPlay === "Threat map"}
                onClick={() => handlePlaySelect("Threat map")}
              />
            </div>
          </div>
        </DrawerContainer>
      </DrawerComponent>
    </div>
  );
};

export default PitchInfo;
